import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";
import { useApp } from "../contexts/AppContext";

export default function ArtistDetailPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const { t } = useApp();
  useEffect(() => {
    api.get(`/artists/${slug}`).then((r) => setData(r.data));
  }, [slug]);
  if (!data) return <div className="min-h-screen flex items-center justify-center text-[var(--text-2)]">{t.common.loading}</div>;
  const { artist, products } = data;

  return (
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-16" data-testid="artist-detail">
      <div className="grid md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-5 aspect-[3/4] card-flat zoom-wrap">
          <img src={artist.image_url} alt={artist.name} className="w-full h-full object-cover grayscale" />
        </div>
        <div className="md:col-span-7">
          <div className="eyebrow mb-3">{t.artists.theArtist}</div>
          <h1 className="section-title text-6xl md:text-8xl leading-none">{artist.name.toUpperCase()}</h1>
          <p className="text-[var(--text-2)] mt-8 max-w-2xl leading-relaxed">{artist.bio}</p>
        </div>
      </div>

      <div className="mt-24">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="eyebrow mb-3">{t.artists.curatedVinyl}</div>
            <h2 className="section-title text-4xl md:text-5xl">{t.artists.discography}</h2>
          </div>
          <Link to="/catalog" className="metadata hover:text-[var(--primary)]">{t.artists.viewAllReleases}</Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {products.map((p) => <ProductCard key={p.id} product={p} artistName={artist.name} artistSlug={artist.slug} artistId={artist.id} />)}
          {products.length === 0 && <div className="col-span-full text-[var(--text-2)]">{t.artists.noReleases}</div>}
        </div>
      </div>
    </div>
  );
}
